import { Link } from 'react-router-dom';

export default function TestimonialSection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-[40%]">
            <div className="relative rounded-[32px] overflow-hidden aspect-[3/4] bg-accent-100/50">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20young%20fashion%20enthusiast%20holding%20shopping%20bags%20with%20sneakers%20and%20streetwear%20items%2C%20standing%20against%20clean%20minimalist%20cream%20wall%2C%20soft%20warm%20natural%20daylight%2C%20genuine%20joyful%20expression%2C%20lifestyle%20editorial%20photography%20with%20gentle%20shadows%2C%20modern%20aesthetic%20portrait%20style&width=600&height=800&seq=testimonial-hoobuy-2026&orientation=portrait"
                alt="Avaliação verificada HoobuySpreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-[60%]">
            <span className="text-xs font-medium text-accent-600 uppercase tracking-wider mb-4 block">
              Avaliação Verificada
            </span>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-950 mb-1 leading-tight">
              A melhor ferramenta
            </h2>
            <p className="text-2xl md:text-3xl font-heading font-extralight text-foreground-400 mb-8">
              para compras na China
            </p>

            <blockquote className="text-base md:text-lg text-foreground-600 font-light leading-relaxed mb-8 max-w-[560px] before:content-['\201C'] after:content-['\201D']">
              Descobri o HoobuySpreadsheet há três meses e mudou completamente a minha forma de comprar. Os preços são imbatíveis e a curadoria é excelente — encontro sempre produtos que estão a bombar nas redes sociais antes de toda a gente. Recomendo a todos que{' '}
              <Link
                to="/"
                className="text-accent-600 hover:text-accent-700 font-medium underline underline-offset-2"
              >
                voltem à página inicial
              </Link>
              {' '}para explorar todas as categorias disponíveis.
            </blockquote>

            <p className="text-sm font-semibold text-foreground-900">
              &mdash; Maria S., Compradora Frequente
            </p>

            <div className="flex items-center gap-3 mt-8">
              <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-400 hover:bg-background-200 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-line text-sm"></i>
                </div>
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}